import { Controller } from '@hotwired/stimulus'

// Renders a Cloudflare Turnstile widget explicitly.
//
// Turnstile's own auto-render only scans the DOM on DOMContentLoaded, which
// Turbo Drive never fires on a navigation, so the widget has to be rendered
// from a lifecycle hook that Turbo does run. Rendering here also means each
// widget is torn down and recreated on every visit, which gives us a fresh
// single-use token instead of a stale one.
const API_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'

let apiPromise = null

function loadTurnstileApi() {
  if (window.turnstile) return Promise.resolve(window.turnstile)
  if (apiPromise) return apiPromise

  apiPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = API_URL
    script.async = true
    script.defer = true
    script.onload = () => resolve(window.turnstile)
    script.onerror = () => {
      apiPromise = null
      reject(new Error('Turnstile API failed to load'))
    }
    document.head.appendChild(script)
  })

  return apiPromise
}

export default class extends Controller {
  static values = {
    sitekey: String,
    action: String,
    // "interaction-only" keeps the widget invisible unless the visitor is
    // actually asked to solve something.
    appearance: { type: String, default: 'interaction-only' }
  }

  connect() {
    loadTurnstileApi()
      .then((turnstile) => {
        // The visitor may have navigated away while the API was loading.
        if (!this.element.isConnected) return

        this.widgetId = turnstile.render(this.element, {
          sitekey: this.sitekeyValue,
          action: this.actionValue,
          appearance: this.appearanceValue
        })
      })
      .catch((error) => console.warn('[turnstile]', error.message))
  }

  disconnect() {
    if (!this.widgetId || !window.turnstile) return

    window.turnstile.remove(this.widgetId)
    this.widgetId = undefined
  }
}
